import { useEffect, useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Calendar } from "@/components/ui/calendar";
import { api, errMsg } from "@/lib/api";

const iso = (d) => d.toLocaleDateString("en-CA");

export function AgentCalendar() {
  const [date, setDate] = useState(new Date());
  const [events, setEvents] = useState([]);
  const [title, setTitle] = useState("");
  const load = () => api.get("/r/events").then((r) => setEvents(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const dayEvents = events.filter((e) => e.date === iso(date));
  const marked = events.map((e) => new Date(e.date + "T00:00:00"));

  const add = async () => {
    if (!title.trim()) return;
    try {
      await api.post("/r/events", { data: { title, date: iso(date), factory: "main" } });
      setTitle(""); load(); toast.success("تمت إضافة المهمة");
    } catch (e) { toast.error(errMsg(e)); }
  };
  const remove = async (id) => { await api.delete(`/r/events/${id}`); load(); };

  return (
    <div className="space-y-4" data-testid="agent-calendar">
      <div className="panel p-2 flex justify-center">
        <Calendar mode="single" selected={date} onSelect={(d) => d && setDate(d)} modifiers={{ marked }} dir="rtl"
          modifiersClassNames={{ marked: "relative after:content-[''] after:absolute after:bottom-1 after:left-1/2 after:-translate-x-1/2 after:h-1 after:w-1 after:rounded-full after:bg-cyan-300" }} />
      </div>
      <div>
        <p className="text-xs text-slate-400 mb-2">{date.toLocaleDateString("ar-SA", { dateStyle: "full" })}</p>
        <div className="flex gap-2">
          <input data-testid="calendar-event-input" value={title} onChange={(e) => setTitle(e.target.value)} onKeyDown={(e) => e.key === "Enter" && add()} placeholder="مهمة جديدة لهذا اليوم..."
            className="flex-1 h-10 rounded-xl bg-white/[0.05] border border-white/[0.08] px-3 text-sm text-slate-100 outline-none focus:ring-2 focus:ring-cyan-400/40" />
          <button data-testid="calendar-add-event-button" onClick={add} className="h-10 w-10 rounded-xl bg-cyan-400 text-slate-950 grid place-items-center hover:bg-cyan-300"><Plus size={18} /></button>
        </div>
      </div>
      <div className="space-y-2" data-testid="calendar-day-events">
        {dayEvents.length === 0 && <p className="text-xs text-slate-500 text-center py-4">لا مهام في هذا اليوم</p>}
        {dayEvents.map((e) => (
          <div key={e.id} className="flex items-start justify-between gap-2 rounded-xl bg-white/[0.03] border border-white/[0.05] px-3 py-2.5">
            <div>
              <p className="text-sm text-slate-100">{e.title}</p>
              {e.note && <p className="text-xs text-slate-500 mt-0.5">{e.note}</p>}
              {e.time && <p className="text-[11px] font-mono text-cyan-300 mt-0.5">{e.time}</p>}
            </div>
            <button data-testid={`calendar-delete-${e.id}`} onClick={() => remove(e.id)} className="text-slate-500 hover:text-red-400"><Trash2 size={14} /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
